import { ErrorViewTemplate } from './error-view-template';

export const NobodyView = ({ message }: { message: React.ReactNode }) => {
  return (
    <ErrorViewTemplate
      title="Vous n'avez pas accès à cette page"
      message={message}
      disableHomeButton={true}
    />
  );
};
